import { AppContainer } from "react-hot-loader";
import * as React from "react";
import * as ReactDOM from "react-dom";
import Login from "./components/Login";
import "./css/Login.css";

/* global document, Office, module, require */

let isOfficeInitialized = false;

const render = (Component, elementId) => {
  ReactDOM.render(
    <AppContainer>
      <Component isOfficeInitialized={isOfficeInitialized} />
    </AppContainer>,
    document.getElementById(elementId),
  );
};

/* Render application after Office initializes */
Office.onReady(() => {
  isOfficeInitialized = true;
  render(Login, "loginContainer");
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/Login", () => {
    const NextApp = require("./components/Login").default;
    render(NextApp, "loginContainer");
  });
}
